// extracted by mini-css-extract-plugin
export var indeterminate = "_4e-5";
export var md = "_4e-4";
export var semantic = "_4e-6";
export var sm = "_4e-3";
export var text = "_4e-7";
export var toggleInput = "_4e-0";
export var toggleSwitch = "_4e-1";
export var xs = "_4e-2";